<section class="h-full flex flex-col gap-2 z-0 relative overflow-y-auto p-2 lg:pl-0">
    <div class="lg:flex flex-1 gap-2">
        <!-- Trip Form -->

        <div
            class="overflow-hidden h-full p-4 rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 shadow-lg flex-1">
            <form [formGroup]="newTripForm" (ngSubmit)="onCreateTrip()">
                <div>
                    <div class="flex items-center justify-between flex-wrap gap-2 px-4 py-2">
                        <h3 class="text-lg font-medium leading-6 text-xs-dark">
                            {{ tripId || standingOrderId ? "Edit" : "Add" }}
                        </h3>
                        <div class="flex justify-between gap-2">
                        
                            <div *ngIf="fareDetails?.total" class="text-xs-light gap-1 rounded-lg ring-1 ring-primary/100 p-2 bg-primary/5">
                                <ul class="flex flex-wrap space-y-1">
                                    <li class="flex items-center justify-between w-full">
                                        <div class="flex items-center space-x-1">
                                            <div class="text-xs text-primary">Trip Fare: </div>
                                        </div>
                                        <p class="text-xs-dark ml-1">
                                            <span class="text-white bg-blue-800 p-1 rounded-md">
                                                ${{ formatValue(fareDetails.baseFare + fareDetails.perMileFare) || 0 }}
                                            </span>
                                        </p>
                                    </li>
                                </ul>
                            </div>
                        
                            <div *ngIf="fareDetails?.addonFareFixed"
                                class="text-xs-light gap-1 rounded-lg ring-1 ring-primary/100 p-2 bg-primary/5">
                                <ul class="flex flex-wrap space-y-1">
                                    <li class="flex items-center justify-between w-full">
                                        <div class="flex items-center space-x-1">
                                            <div class="text-xs text-primary">Addons Fare: </div>
                                        </div>
                                        <p class="text-xs-dark ml-1">
                                            <span class="text-white bg-blue-800 p-1 rounded-md">
                                                ${{ formatValue(fareDetails.addonFareFixed) || 0 }}
                                            </span>
                                        </p>
                                    </li>
                                </ul>
                            </div>
                        
                            <div *ngIf="fareDetails?.total" class="text-xs-light gap-1 rounded-lg ring-1 ring-primary/100 p-2 bg-primary/5">
                                <ul class="flex flex-wrap space-y-1">
                        
                                    <li class="flex items-center justify-between w-full">
                                        <div class="flex items-center space-x-1">
                                            <div class="text-xs text-primary">Total Fare: </div>
                                        </div>
                                        <p class="text-xs-dark ml-1">
                                            <span class="text-white bg-blue-800 p-1 rounded-md">
                                                ${{ formatValue(fareDetails.total) || 0 }}
                                            </span>
                                        </p>
                                    </li>
                        
                                </ul>
                            </div>
                        
                            <div *ngIf="fareDetails?.total"
                                class="text-xs-light gap-1 rounded-lg ring-1 ring-green-600 p-2 bg-green-600 text-white shadow-md">
                                <ul class="flex flex-wrap space-y-1">
                        
                                    <li class="flex items-center justify-between w-full">
                                        <div class="flex items-center space-x-1">
                                            <div class="text-xs font-semibold dark:text-white">Grand Total:</div>
                                        </div>
                                        <p class="text-xs-dark ml-1">
                                            <span class="bg-white text-green-700 px-2 py-1 rounded-md font-bold shadow-sm">
                                                ${{ grandTotal(fareDetails) || 0 }}
                                            </span>
                                        </p>
                                    </li>
                        
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="w-96 mt-4">
                        <label for="member" class="block text-sm font-medium text-main-secondary">Member <span
                                class="text-red-600">*</span></label>
                        <div class="mt-1 flex gap-1">
                            <ng-select id="member" [notFoundText]="'No record found'" formControlName="member"
                                [clearable]="true" (scrollToEnd)="onScroll()" [searchable]="true"
                                (search)="onSearch($event)" [searchable]="true" (clear)="onClear()" (close)="onClose()"
                                (change)="onSelectMember($event)" [ngClass]="
                  submitted && form.member.errors?.required
                    ? 'border-main-danger'
                    : 'border-gray-300'
                " class="w-full">
                                <ng-option *ngIf="memberList.length > 0" value="">
                                    Select Member
                                </ng-option>
                                <ng-option *ngFor="let member of memberList" value="{{ member.id }}">
                                    {{((member.displayName) | titlecase) + (member.contactNumber ? " - " + member.contactNumber : "") + (member?.dateOfBirth ? " - " + (member.dateOfBirth | dobFormatter:'MM/DD/YYYY') : "") }}</ng-option>
                            </ng-select>
                            <ng-container *ngIf="permissionService.hasPermission([userPermission.GET_MEMBER, userPermission.MANAGE_MEMBER])">
                                <button [appToolTip]="'Add Member'" *ngIf="!form.member.value" (click)="openAddMemberModal()"
                                    class="btn btn-secondary" type="button">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                                        class="w-5 h-5">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                                    </svg>
                                </button>
                                <button [appToolTip]="'Edit Member'" *ngIf="form.member.value" (click)="openAddMemberModal()"
                                    class="btn btn-secondary" type="button">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor"
                                        class="w-5 h-5">
                                        <path stroke-linecap="round" stroke-linejoin="round"
                                            d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10" />
                                    </svg>
                                </button>
                            </ng-container>
                        </div>
                        <div *ngIf="form.member.errors && submitted">
                            <div *ngIf="form.member.errors.required" class="error">
                                <p class="mt-2 text-red-600 text-xs">Member is required</p>
                            </div>
                        </div>
                    </div>
                    <div class="mt-4 grid grid-cols-1 gap-2 sm:grid-cols-6">
                        <div class="sm:col-span-2">
                            <label for="reference" class="block text-sm font-medium text-main-secondary">Reference ID
                            </label>
                            <div class="mt-1">
                                <input formControlName="reference" type="text" name="reference" id="reference" />
                            </div>
                        </div>

                            <!-- suffix -->
                        <div class="sm:col-span-2" *ngIf="tripId || StandingOrderId">
                            <label for="suffix" class="block text-sm font-medium text-main-secondary">Leg
                            </label>
                            <div class="mt-1">
                                <input formControlName="suffix" type="text" name="suffix" id="suffix" />
                            </div>
                        </div>
                        
                        <div class="sm:col-span-2">
                            <label for="spaceType" class="block text-sm font-medium text-main-secondary">Space Type
                                <span class="text-red-600">*</span></label>
                            <div class="mt-1">
                                <ng-select id="spaceType" formControlName="spaceType" [clearable]="false" class="" [ngClass]="
                                                    submitted && form.spaceType.errors?.required
                                                      ? 'border-main-danger'
                                                      : 'border-gray-300'
                                                  " (change)="onSelectSpaceType($event)">
                                    <ng-option value="">
                                        Select Space Type
                                    </ng-option>
                                    <ng-option *ngFor="let spaceType of spaceTypeMainList" value="{{ spaceType.id }}">{{
                                        spaceType.title | uppercase }}
                                        <span *ngIf="!preSpaceTypeFares?.[spaceType.id]"
                                            class="ml-2 px-1.5 h-4 whitespace-nowrap inline-flex items-center justify-center text-[10px] font-medium bg-red-100 text-red-600 rounded-md border border-red-200">
                                            No Fare
                                        </span>
                                    </ng-option>
                                </ng-select>
                            </div>
                            <div *ngIf="form.spaceType.errors && submitted">
                                <div *ngIf="form.spaceType.errors.required" class="error">
                                    <p class="mt-2 text-red-600 text-xs">
                                        Space Type is required
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div formGroupName="pickup" name="pickup">
                        <div class="mt-4">
                            <h3 class="text-lg font-medium leading-6 text-xs-dark">Pickup</h3>
                        </div>
                        <div class="mt-4 grid grid-cols-1 gap-2 sm:grid-cols-6">
                            <div
                                class="sm:col-span-6 border-2 border-dashed border-zinc-950/10 dark:border-white/10 p-2 rounded-lg space-y-2">
                                <div>
                                    <div class="grid grid-cols-1 gap-2 sm:grid-cols-6">
                                        <div class="col-span-full grid grid-cols-1 gap-2 sm:grid-cols-6">
                                            <div class="sm:col-span-2">
                                                <label for="Address"
                                                    class="block text-sm font-medium text-main-secondary">Time
                                                </label>
                                                <div class="mt-1 relative">
                                                    <input type="text" name="pickupTime" id="pickupTime" [readOnly]="true"
                                                        formControlName="time" [owlDateTime]="dtPickUpTime"
                                                        [owlDateTimeTrigger]="dtPickUpTime" />
                                                    <div
                                                        class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
                                                        <span class="text-gray-500 sm:text-sm" id="price-currency">
                                                            <svg xmlns="http://www.w3.org/2000/svg"
                                                                class="h-5 w-5 text-xs-light" viewBox="0 0 24 24">
                                                                <g fill="none" stroke="currentColor"
                                                                    stroke-linecap="round" stroke-linejoin="round"
                                                                    stroke-width="2">
                                                                    <path
                                                                        d="M11.795 21H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4" />
                                                                    <path
                                                                        d="M14 18a4 4 0 1 0 8 0a4 4 0 1 0-8 0m1-15v4M7 3v4m-4 4h16" />
                                                                    <path d="M18 16.496V18l1 1" />
                                                                </g>
                                                            </svg>
                                                        </span>
                                                    </div>
                                                </div>

                                                <div *ngIf="pickUpForm.controls.time.errors && submitted">
                                                    <div *ngIf="pickUpForm.controls.time.errors.required" class="error">
                                                        <p class="mt-2 text-red-600 text-xs">
                                                            Time is required
                                                        </p>
                                                    </div>
                                                    <div *ngIf="
                              pickUpForm.controls.time.errors.owlDateTimeMin
                            " class="error">
                                                        <p class="mt-2 text-red-600 text-xs">
                                                            Time is required
                                                        </p>
                                                    </div>
                                                </div>
                                                <owl-date-time (afterPickerClosed)="
                            onPickupDateChange(pickUpForm.get('time'))
                          " #dtPickUpTime></owl-date-time>
                                            </div>

                                            <div class="sm:col-span-2" formGroupName="address">
                                                <label for="Address"
                                                    class="block text-sm font-medium text-main-secondary">Address <span
                                                        class="text-red-600">*</span>
                                                </label>
                                                <div class="mt-1 flex gap-px">
                                                    <input type="text" id="pickupAddress" class=""
                                                        placeholder="Enter the address" name="pickupAddress" googlePlace
                                                        formControlName="name" (onSelect)="setOriginAddress($event)" (input)="onChangeOriginAddress()" />
                                                </div>

                                
                                                <div *ngIf="submitted">
                                                    <div class="error">
                                                        <p *ngIf="pickUpForm.get('address.name')?.errors?.required" class="mt-2 text-red-600 text-xs">
                                                            Address is required
                                                        </p>
                                                        <p *ngIf="pickUpForm.get('address')?.errors?.invalidAddress"
                                                            class="mt-2 text-red-600 text-xs">
                                                            Invalid address (select from the dropdown)
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <details class="col-span-full group">
                                            <summary class="flex items-center justify-between cursor-pointer">
                                                <div class="text-xs font-bold underline flex items-center">
                                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none"
                                                        viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                                                        class="size-4">
                                                        <path stroke-linecap="round" stroke-linejoin="round"
                                                            d="M15.042 21.672 13.684 16.6m0 0-2.51 2.225.569-9.47 5.227 7.917-3.286-.672ZM12 2.25V4.5m5.834.166-1.591 1.591M20.25 10.5H18M7.757 14.743l-1.59 1.59M6 10.5H3.75m4.007-4.243-1.59-1.59" />
                                                    </svg>
                                                    Additional Information
                                                </div>
                                                <svg class="h-5 w-5 transition-transform duration-300 ease-in-out group-open:rotate-180"
                                                    xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                                    stroke="currentColor">
                                                    <path stroke-linecap="round" stroke-linejoin="round"
                                                        stroke-width="2" d="M19 9l-7 7-7-7">
                                                    </path>
                                                </svg>
                                            </summary>
                                            <div
                                                class="mt-2 grid grid-cols-1 gap-2 sm:grid-cols-6 items-end border p-2 rounded-lg bg-zinc-950/5 dark:bg-white/5 border-zinc-950/10 dark:border-white/10">
                                                <ng-container formGroupName="address">
                                                    <div class="sm:col-span-2">
                                                        <label for="floor"
                                                            class="block text-sm font-medium text-main-secondary">Floor
                                                        </label>
                                                        <div class="mt-1">
                                                            <input formControlName="floor" type="text" name="floor"
                                                                id="floor" />
                                                        </div>
                                                        <!-- <div *ngIf="originAddressAdditionalForm.get('floor')?.errors && submitted">
                                                    <div *ngIf="originAddressAdditionalForm.get('floor')?.errors?.required"
                                                        class="error">
                                                        <p class="mt-2 text-red-600 text-xs">
                                                            Floor is required
                                                        </p>
                                                    </div>
                                                </div> -->
                                                    </div>
                                                    <div class="sm:col-span-2">
                                                        <label for="aptOrSuite"
                                                            class="block text-sm font-medium text-main-secondary">APT/SUITE
                                                        </label>
                                                        <div class="mt-1">
                                                            <input formControlName="aptSuiteRoom" type="text"
                                                                name="aptOrSuite" id="aptOrSuite" />
                                                        </div>
                                                        <!-- <div
                                                    *ngIf="originAddressAdditionalForm.get('aptOrSuite')?.errors && submitted">
                                                    <div *ngIf="originAddressAdditionalForm.get('aptOrSuite')?.errors?.required"
                                                        class="error">
                                                        <p class="mt-2 text-red-600 text-xs">
                                                            APT/SUITE is required
                                                        </p>
                                                    </div>
                                                </div> -->
                                                    </div>
                                                </ng-container>
                                                <div class="sm:col-span-2">
                                                    <label for="placeName"
                                                        class="block text-sm font-medium text-main-secondary">Place Type
                                                    </label>
                                                    <div class="mt-1">
                                                        <select name="placeNameAddres" id="placeNameAddres"
                                                            formControlName="placeName">
                                                            <option value="">Select Place Name</option>
                                                            <option *ngFor="let placetype of placetypes"
                                                                value="{{ placetype.title }}">
                                                                {{ placetype.title | titlecase }}
                                                            </option>
                                                        </select>
                                                    </div>
                                                    <!-- <div
                                                    *ngIf="originAddressAdditionalForm.get('aptOrSuite')?.errors && submitted">
                                                    <div *ngIf="originAddressAdditionalForm.get('aptOrSuite')?.errors?.required"
                                                        class="error">
                                                        <p class="mt-2 text-red-600 text-xs">
                                                            Home/Facility Name is required
                                                        </p>
                                                    </div>
                                                </div> -->
                                                </div>
                                                <div class="sm:col-span-2">
                                                    <label for="phoneNumber"
                                                        class="block text-sm font-medium text-main-secondary">Contact
                                                        Number
                                                    </label>
                                                    <div class="mt-1">
                                                        <input formControlName="phoneNumber" type="text"
                                                            name="phoneNumber" id="phoneNumber" />
                                                    </div>
                                                </div>
                                            </div>
                                        </details>
                                        <div *ngIf="submitted && pickUpForm.get('phoneNumber')?.errors">
                                            <p *ngIf="submitted && (pickUpForm.get('phoneNumber')?.errors?.minlength || pickUpForm.get('phoneNumber')?.errors ?.maxlength)"
                                                class="pt-1 text-red-600 text-xs">
                                                Minimum 10 digits are required and maximum 13
                                                digits are allowed
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div formGroupName="destination" name="destination">
                        <div class="mt-4">
                            <h3 class="text-lg font-medium leading-6 text-xs-dark">
                                Dropoff
                            </h3>
                        </div>
                        <div class="mt-4 grid grid-cols-1 gap-2 sm:grid-cols-6">
                            <div
                                class="sm:col-span-6 border-2 border-dashed border-zinc-950/10 dark:border-white/10 p-2 rounded-lg space-y-2">
                                <div>
                                    <div class="grid grid-cols-1 gap-2 sm:grid-cols-6">
                                        <div class="col-span-full grid grid-cols-1 gap-2 sm:grid-cols-6">
                                            <div class="sm:col-span-2">
                                                <label for="Address"
                                                    class="block text-sm font-medium text-main-secondary">Time
                                                </label>
                                                <div class="mt-1 relative">
                                                    <input type="text" name="dropoffTime" id="dropoffTime" [readOnly]="true"
                                                        formControlName="time" [owlDateTime]="dtDropOffTime"
                                                        [owlDateTimeTrigger]="dtDropOffTime" />
                                                    <div
                                                        class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
                                                        <span class="text-gray-500 sm:text-sm" id="price-currency">
                                                            <svg xmlns="http://www.w3.org/2000/svg"
                                                                class="h-5 w-5 text-xs-light" viewBox="0 0 24 24">
                                                                <g fill="none" stroke="currentColor"
                                                                    stroke-linecap="round" stroke-linejoin="round"
                                                                    stroke-width="2">
                                                                    <path
                                                                        d="M11.795 21H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4" />
                                                                    <path
                                                                        d="M14 18a4 4 0 1 0 8 0a4 4 0 1 0-8 0m1-15v4M7 3v4m-4 4h16" />
                                                                    <path d="M18 16.496V18l1 1" />
                                                                </g>
                                                            </svg>
                                                        </span>
                                                    </div>
                                                </div>

                                                <div *ngIf="dropOffForm.controls.time.errors && submitted">
                                                    <div *ngIf="dropOffForm.controls.time.errors.required"
                                                        class="error">
                                                        <p class="mt-2 text-red-600 text-xs">
                                                            Time is required
                                                        </p>
                                                    </div>
                                                    <div *ngIf="
                              dropOffForm.controls.time.errors.owlDateTimeMin
                            " class="error">
                                                        <p class="mt-2 text-red-600 text-xs">
                                                            Time is required
                                                        </p>
                                                    </div>
                                                </div>
                                                <owl-date-time (afterPickerClosed)="
                            onDateChange(dropOffForm.get('time'))
                          " #dtDropOffTime></owl-date-time>
                                            </div>

                                            <div formGroupName="address" class="sm:col-span-2">
                                                <label for="Address"
                                                    class="block text-sm font-medium text-main-secondary">Address <span
                                                        class="text-red-600">*</span>
                                                </label>
                                                <div class="mt-1 flex gap-px">
                                                    <input type="text" id="dropoffAddress" class=""
                                                        placeholder="Enter the address" name="pickupAddress" googlePlace
                                                        formControlName="name"
                                                        (onSelect)="setDestinationAddress($event)" (input)="onChangeDestinationAddress()" />
                                                </div>

                                            
                                                <div *ngIf="submitted">
                                                    <div class="error">
                                                        <p *ngIf="dropOffForm.get('address.name')?.errors?.required" class="mt-2 text-red-600 text-xs">
                                                            Address is required
                                                        </p>
                                                
                                                    
                                                        <p *ngIf="dropOffForm.get('address')?.errors?.invalidAddress"
                                                            class="mt-2 text-red-600 text-xs">
                                                            Invalid address (select from the dropdown)
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <details class="col-span-full group">
                                            <summary class="flex items-center justify-between cursor-pointer">
                                                <div class="text-xs font-bold underline flex items-center">
                                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none"
                                                        viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                                                        class="size-4">
                                                        <path stroke-linecap="round" stroke-linejoin="round"
                                                            d="M15.042 21.672 13.684 16.6m0 0-2.51 2.225.569-9.47 5.227 7.917-3.286-.672ZM12 2.25V4.5m5.834.166-1.591 1.591M20.25 10.5H18M7.757 14.743l-1.59 1.59M6 10.5H3.75m4.007-4.243-1.59-1.59" />
                                                    </svg>
                                                    Additional Information
                                                </div>
                                                <svg class="h-5 w-5 transition-transform duration-300 ease-in-out group-open:rotate-180"
                                                    xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                                    stroke="currentColor">
                                                    <path stroke-linecap="round" stroke-linejoin="round"
                                                        stroke-width="2" d="M19 9l-7 7-7-7">
                                                    </path>
                                                </svg>
                                            </summary>
                                            <div
                                                class="mt-2 grid grid-cols-1 gap-2 sm:grid-cols-6 items-end border p-2 rounded-lg bg-zinc-950/5 dark:bg-white/5 border-zinc-950/10 dark:border-white/10">
                                                <ng-container formGroupName="address">
                                                    <div class="sm:col-span-2">
                                                        <label for="floordest"
                                                            class="block text-sm font-medium text-main-secondary">Floor
                                                        </label>
                                                        <div class="mt-1">
                                                            <input formControlName="floor" type="text" name="floordest"
                                                                id="floordest" />
                                                        </div>
                                                        <!-- <div *ngIf="originAddressAdditionalForm.get('floor')?.errors && submitted">
                                                    <div *ngIf="originAddressAdditionalForm.get('floor')?.errors?.required"
                                                        class="error">
                                                        <p class="mt-2 text-red-600 text-xs">
                                                            Floor is required
                                                        </p>
                                                    </div>
                                                </div> -->
                                                    </div>
                                                    <div class="sm:col-span-2">
                                                        <label for="aptOrSuitedest"
                                                            class="block text-sm font-medium text-main-secondary">APT/SUITE
                                                        </label>
                                                        <div class="mt-1">
                                                            <input formControlName="aptSuiteRoom" type="text"
                                                                name="aptOrSuitedest" id="aptOrSuitedest" />
                                                        </div>
                                                        <!-- <div
                                                    *ngIf="originAddressAdditionalForm.get('aptOrSuite')?.errors && submitted">
                                                    <div *ngIf="originAddressAdditionalForm.get('aptOrSuite')?.errors?.required"
                                                        class="error">
                                                        <p class="mt-2 text-red-600 text-xs">
                                                            APT/SUITE is required
                                                        </p>
                                                    </div>
                                                </div> -->
                                                    </div>
                                                </ng-container>
                                                <div class="sm:col-span-2">
                                                    <label for="placeNamedest"
                                                        class="block text-sm font-medium text-main-secondary">Place Type
                                                    </label>
                                                    <div class="mt-1">
                                                        <select name="placeNameDest" id="placeNameDest"
                                                            formControlName="placeName">
                                                            <option value="">Select Place Name</option>
                                                            <option *ngFor="let placetype of placetypes"
                                                                value="{{ placetype.title }}">
                                                                {{ placetype.title | titlecase}}
                                                            </option>
                                                        </select>
                                                    </div>
                                                    <!-- <div
                                                    *ngIf="originAddressAdditionalForm.get('aptOrSuite')?.errors && submitted">
                                                    <div *ngIf="originAddressAdditionalForm.get('aptOrSuite')?.errors?.required"
                                                        class="error">
                                                        <p class="mt-2 text-red-600 text-xs">
                                                            Home/Facility Name is required
                                                        </p>
                                                    </div>
                                                </div> -->
                                                </div>
                                                <div class="sm:col-span-2">
                                                    <label for="phoneNumberdest"
                                                        class="block text-sm font-medium text-main-secondary">Contact
                                                        Number
                                                    </label>
                                                    <div class="mt-1">
                                                        <input formControlName="phoneNumber" type="text"
                                                            name="phoneNumberdest" id="phoneNumberdest"
                                                             />
                                                    </div>
                                                </div>
                                            </div>
                                        </details>
                                        <div *ngIf="submitted && dropOffForm.get('phoneNumber')?.errors">
                                            <p *ngIf="submitted && (dropOffForm.get('phoneNumber')?.errors?.minlength || dropOffForm.get('phoneNumber')?.errors ?.maxlength)"
                                                class="pt-1 text-red-600 text-xs">
                                                Minimum 10 digits are required and maximum 13
                                                digits are allowed
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mt-4 grid grid-cols-1 gap-2 sm:grid-cols-6">
                        <div class="sm:col-span-2">
                            <label for="appointmentType"
                                class="block text-sm font-medium text-main-secondary">Appointment Type
                            </label>
                            <div class="mt-1">
                                <select formControlName="appointmentType" class="">
                                    <option value="">Select Appointment Type</option>
                                    <option *ngFor="let item of appointmentTypes" value="{{ item.id }}">
                                        {{ item.title | titlecase }}
                                    </option>
                                </select>
                            </div>
                            <div *ngIf="form.appointmentType.errors && submitted">
                                <div *ngIf="form.appointmentType.errors.required" class="error">
                                    <p class="mt-2 text-red-600 text-xs">
                                        Appointment Type is required
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="sm:col-span-2">
                            <label for="miles" class="block text-sm font-medium text-main-secondary">Miles</label>
                            <div class="mt-1">
                                <input type="number" formControlName="miles" id="miles" />
                            </div>
                            <!-- <div *ngIf="form.miles.errors && submitted">
                                <div *ngIf="form.miles.errors.required" class="error">
                                    <p class="mt-2 text-red-600 text-xs">
                                        Miles is required
                                    </p>
                                </div>
                            </div> -->
                        </div>

                        <div class="sm:col-span-2">
                            <label for="additionalPassenger"
                                class="block text-sm font-medium text-main-secondary">
                                Escorts</label>
                            <div class="mt-1">
                                <select id="additionalPassenger" formControlName="additionalPassenger">
                                    <option value="">Select Escorts</option>
                                    <option *ngFor="let noOfEscort of [1, 2, 3, 4, 5]" value="{{ noOfEscort }}">
                                        {{ noOfEscort }}
                                    </option>
                                </select>
                            </div>
                            <!-- <div *ngIf="form.additionalPassenger.errors && submitted">
                                <div *ngIf="form.additionalPassenger.errors.required" class="error">
                                    <p class="mt-2 text-red-600 text-xs">
                                        No. Of Escorts is required
                                    </p>
                                </div>
                            </div> -->
                        </div>
                        <div class="sm:col-span-2">
                            <label for="additionalPassenger"
                                class="block text-sm font-medium text-main-secondary">Requester
                                Name</label>
                            <div class="mt-1">
                                <input type="text" formControlName="requesterName" id="requesterName" />
                            </div>
                            <!-- <div *ngIf="form.additionalPassenger.errors && submitted">
                                <div *ngIf="form.additionalPassenger.errors.required" class="error">
                                    <p class="mt-2 text-red-600 text-xs">
                                        No. Of Escorts is required
                                    </p>
                                </div>
                            </div> -->
                        </div>
                    </div>
                    <div class="mt-6 grid grid-cols-1 gap-2 sm:grid-cols-6">
                        <div class="sm:col-span-3">
                            <label for="generalNotes" class="block text-sm font-medium text-main-secondary">General
                                Notes
                                <!-- <span class="text-gray-400">(Public)</span> -->
                            </label>
                            <div class="mt-1">
                                <textarea formControlName="generalNotes" name="generalNotes"
                                    id="generalNotes"></textarea>
                            </div>
                        </div>
                        <div class="sm:col-span-3">
                            <label for="privateNotes" class="block text-sm font-medium text-main-secondary">Private
                                Notes
                                <!-- <span class="text-gray-400">(Private)</span> -->
                            </label>
                            <div class="mt-1">
                                <textarea formControlName="privateNotes" name="privateNotes"
                                    id="privateNotes"></textarea>
                            </div>
                        </div>
                    </div>
                    <div class="mt-4 space-y-2">
                        <!-- Attachments Header -->
                        <div class="flex items-center justify-between">
                            <div class="flex items-center gap-1 text-primary">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                    stroke-width="1.5" stroke="currentColor" class="size-4">
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="m18.375 12.739-7.693 7.693a4.5 4.5 0 0 1-6.364-6.364l10.94-10.94A3 3 0 1 1 19.5 7.372L8.552 18.32m.009-.01-.01.01m5.699-9.941-7.81 7.81a1.5 1.5 0 0 0 2.112 2.13" />
                                </svg>
                                <h2 class="subheading text-primary">Attachments</h2>
                            </div>
                        </div>

                        <!-- Upload Section -->
                        <div
                            class="border-2 border-dashed border-zinc-950/10 dark:border-white/10 rounded-lg flex items-center p-2">
                            <!-- Uploaded Files List -->
                            <ul class="relative max-w-full flex w-auto snap-x snap-mandatory gap-4 overflow-x-auto p-4"
                                *ngIf="form.attachments.value.length">
                                <li *ngFor="let file of attachmentForm.controls; let i = index"
                                    class="relative flex w-56 shrink-0 snap-center items-center gap-2 rounded-lg border border-zinc-950/10 dark:border-white/10 p-2 shadow">
                                    <div class="grid h-12 w-10 place-content-center flex-shrink-0">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="size-full text-primary"
                                            viewBox="0 0 16 16">
                                            <g fill="currentColor">
                                                <path
                                                    d="M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm0 1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1" />
                                                <path
                                                    d="M4.603 12.087a.8.8 0 0 1-.438-.42c-.195-.388-.13-.776.08-1.102c.198-.307.526-.568.897-.787a7.7 7.7 0 0 1 1.482-.645a20 20 0 0 0 1.062-2.227a7.3 7.3 0 0 1-.43-1.295c-.086-.4-.119-.796-.046-1.136c.075-.354.274-.672.65-.823c.192-.077.4-.12.602-.077a.7.7 0 0 1 .477.365c.088.164.12.356.127.538c.007.187-.012.395-.047.614c-.084.51-.27 1.134-.52 1.794a11 11 0 0 0 .98 1.686a5.8 5.8 0 0 1 1.334.05c.364.065.734.195.96.465c.12.144.193.32.2.518c.007.192-.047.382-.138.563a1.04 1.04 0 0 1-.354.416a.86.86 0 0 1-.51.138c-.331-.014-.654-.196-.933-.417a5.7 5.7 0 0 1-.911-.95a11.6 11.6 0 0 0-1.997.406a11.3 11.3 0 0 1-1.021 1.51c-.29.35-.608.655-.926.787a.8.8 0 0 1-.58.029" />
                                            </g>
                                        </svg>
                                    </div>
                                    <div class="flex flex-col truncate">
                                        <div class="text-sm-dark truncate flex-1">
                                            {{ file.value.filename }}
                                        </div>
                                        <div class="text-sm-light flex gap-1">
                                            <span>&#x2022;</span>
                                            <a href="{{ file.value.url }}" target="_blank"
                                                class="cursor-pointer hover:text-primary hover:underline">Download</a>
                                        </div>
                                    </div>
                                    <button type="button"
                                        class="absolute -top-2.5 -right-2.5 btn btn-danger rounded-full size-6 grid place-content-center"
                                        (click)="removeAttachment(i)">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                            stroke-width="1.5" stroke="currentColor" class="size-4">
                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                d="M6 18L18 6M6 6l12 12" />
                                        </svg>
                                    </button>
                                </li>
                            </ul>
                            <div>
                                <input type="file" accept="application/pdf" #fileInput class="hidden"
                                    (change)="uploadAttachment($event)" />
                                <div class="cursor-pointer flex shrink-0 snap-center items-center gap-2 rounded-lg border border-zinc-950/10 dark:border-white/10 p-2 shadow h-full"
                                    (click)="fileInput.click()">
                                    <div class="grid h-12 w-10 place-content-center flex-shrink-0">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                            stroke-width="1.5" stroke="currentColor" class="size-5">
                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                d="M12 4.5v15m7.5-7.5h-15" />
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Legs -->
                    <div *ngIf="!(StandingOrderId || tripId)" name="Legs">
                        <div class="mt-4">
                            <h3 class="text-lg font-medium leading-6 text-main-dark">
                                Other Legs
                            </h3>
                        </div>
                        <div class="space-y-2">
                            <ng-container *ngFor="let legItem of legFormGroups; index as legIndex">
                                <fieldset
                                    class="relative bg-main-base-100 border-2 border-dashed border-main-base p-2 rounded-lg dark:border-white/10"
                                    [formGroup]="legItem">
                                    <legend
                                        class="mx-auto text-lg font-bold border-2 border-dashed border-main-base dark:border-white/10 bg-white rounded-lg px-2 dark:bg-zinc-950/5">
                                        Leg-{{ legIndex + 2 }}
                                    </legend>
                                    <div class="absolute right-2 top-2 flex items-center gap-3">
                                        <div *ngIf="legFareEstimation[legIndex]?.total"
                                            class="text-xs-light gap-1 rounded-lg ring-1 ring-primary/100 p-2 bg-primary/5">
                                            <ul class="flex flex-wrap space-y-1">
                                                <li class="flex items-center justify-between w-full">
                                                    <div class="flex items-center space-x-1">
                                                        <div class="text-xs text-primary">Trip Fare: </div>
                                                    </div>
                                                    <p class="text-xs-dark ml-1">
                                                        <span class="text-white bg-blue-800 p-1 rounded-md">
                                                            ${{ (legFareEstimation[legIndex]?.baseFare + legFareEstimation[legIndex]?.perMileFare) || 0}}
                                                        </span>
                                                    </p>
                                                </li>
                                            </ul>
                                        </div>
                                        <div *ngIf="legFareEstimation[legIndex]?.addonFareFixed"
                                            class="text-xs-light gap-1 rounded-lg ring-1 ring-primary/100 p-2 bg-primary/5">
                                            <ul class="flex flex-wrap space-y-1">
                                                <li class="flex items-center justify-between w-full">
                                                    <div class="flex items-center space-x-1">
                                                        <div class="text-xs text-primary">Addons Fare: </div>
                                                    </div>
                                                    <p class="text-xs-dark ml-1">
                                                        <span class="text-white bg-blue-800 p-1 rounded-md">
                                                            ${{ legFareEstimation[legIndex]?.addonFareFixed || 0 }}
                                                        </span>
                                                    </p>
                                                </li>
                                            </ul>
                                        </div>
                                        <div *ngIf="legFareEstimation[legIndex]?.total"
                                            class="text-xs-light gap-1 rounded-lg ring-1 ring-primary/100 p-2 bg-primary/5">
                                            <ul class="flex flex-wrap space-y-1">
                                                <li class="flex items-center justify-between w-full">
                                                    <div class="flex items-center space-x-1">
                                                        <div class="text-xs text-primary">Total Fare: </div>
                                                    </div>
                                                    <p class="text-xs-dark ml-1">
                                                        <span class="text-white bg-blue-800 p-1 rounded-md">
                                                            ${{ legFareEstimation[legIndex]?.total || 0 }}
                                                        </span>
                                                    </p>
                                                </li>
                                            </ul>
                                        </div>
                                        <button type="button" class="btn btn-danger" (click)="removeLegItem(legIndex)">
                                            Remove
                                        </button>
                                    </div>
                                    <div class="mt-6 grid grid-cols-1 gap-2 sm:grid-cols-6">
                                        <div class="sm:col-span-2">
                                            <label for="miles"
                                                class="block text-sm font-medium text-main-secondary">Miles</label>
                                            <div class="mt-1">
                                                <input type="text" formControlName="miles" id="miles" />
                                            </div>
                                            <div *ngIf="legItem.get('miles')?.errors && submitted">
                                                <div *ngIf="legItem.get('miles')?.errors?.required" class="error">
                                                    <p class="mt-2 text-red-600 text-xs">
                                                        Miles are required
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div formGroupName="pickup" name="pickup">
                                        <div class="mt-4">
                                            <h3 class="text-lg font-medium leading-6 text-xs-dark">
                                                Pickup
                                            </h3>
                                        </div>
                                        <div class="mt-4 grid grid-cols-1 gap-2 sm:grid-cols-6">
                                            <div
                                                class="sm:col-span-6 border-2 border-dashed border-zinc-950/10 dark:border-white/10 p-2 rounded-lg space-y-2">
                                                <div>
                                                    <div class="grid grid-cols-1 gap-2 sm:grid-cols-6">
                                                        <div
                                                            class="col-span-full grid grid-cols-1 gap-2 sm:grid-cols-6">
                                                            <div class="sm:col-span-2">
                                                                <div class="flex items-center justify-between">
                                                                    <label for="Address"
                                                                        class="block text-sm font-medium text-main-secondary">
                                                                        <span>Time</span>
                                                                    </label>
                                                                    <div
                                                                        class="flex items-center space-x-2 border border-dashed border-zinc-200 dark:border-white/5 bg-zinc-950/5 dark:bg-white/5 px-2 py-0.5 rounded">
                                                                        <input type="checkbox"
                                                                            class="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                                                                            id="{{ legIndex }}"
                                                                            [(ngModel)]="isWillCall[legIndex]"
                                                                            (change)="setWillCall($event, legIndex)"
                                                                            name="isWillCall{{ legIndex }}"
                                                                            [ngModelOptions]="{ standalone: true }" />
                                                                        <span>Will Call</span>
                                                                    </div>
                                                                </div>
                                                                <div class="mt-1 relative">
                                                                    <input type="text" name="pickupTime" id="pickupTime" formControlName="time" [readOnly]="true" [owlDateTime]="dtPickUpTime"
                                                                        [owlDateTimeTrigger]="dtPickUpTime" [disabled]="isWillCall[legIndex]" />
                                                                    <div
                                                                        class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
                                                                        <span class="text-gray-500 sm:text-sm"
                                                                            id="price-currency">
                                                                            <svg xmlns="http://www.w3.org/2000/svg"
                                                                                class="h-5 w-5 text-xs-light"
                                                                                viewBox="0 0 24 24">
                                                                                <g fill="none" stroke="currentColor"
                                                                                    stroke-linecap="round"
                                                                                    stroke-linejoin="round"
                                                                                    stroke-width="2">
                                                                                    <path
                                                                                        d="M11.795 21H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4" />
                                                                                    <path
                                                                                        d="M14 18a4 4 0 1 0 8 0a4 4 0 1 0-8 0m1-15v4M7 3v4m-4 4h16" />
                                                                                    <path d="M18 16.496V18l1 1" />
                                                                                </g>
                                                                            </svg>
                                                                        </span>
                                                                    </div>
                                                                </div>

                                                                <div *ngIf="
                                    legItem.get('pickup.time')?.errors &&
                                    submitted
                                  ">
                                                                    <div *ngIf="
                                      legItem.get('pickup.time')?.errors
                                        ?.required
                                    " class="error">
                                                                        <p class="mt-2 text-red-600 text-xs">
                                                                            Time is required
                                                                        </p>
                                                                    </div>
                                                                    <div *ngIf="
                                      legItem.get('pickup.time')?.errors
                                        ?.owlDateTimeMin
                                    " class="error">
                                                                        <p class="mt-2 text-red-600 text-xs">
                                                                            Time is required
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                <owl-date-time [disabled]="isWillCall[legIndex]" (afterPickerClosed)="
                                    onLegPickUpDateChange(
                                      legItem,
                                      legItem.controls.pickup.get('time')
                                    )
                                  " #dtPickUpTime></owl-date-time>
                                                            </div>

                                                            <div class="sm:col-span-2" formGroupName="address">
                                                                <label for="Address"
                                                                    class="block text-sm font-medium text-main-secondary">Address
                                                                    <span class="text-red-600">*</span>
                                                                </label>
                                                                <div class="mt-1 flex gap-px">
                                                                    <input type="text" id="pickupAddress" class=""
                                                                        placeholder="Enter the address"
                                                                        name="pickupAddress" googlePlace
                                                                        formControlName="name" (onSelect)="setOriginAddress($event, legIndex)" (input)="onChangeOriginAddress(legIndex)" />
                                                                </div>
                                                                <div *ngIf="submitted">
                                                                    <div class="error">
                                                                        <p *ngIf="legItem.get('pickup.address.name')?.errors?.required" class="mt-2 text-red-600 text-xs">
                                                                            Address is required
                                                                        </p>
                                                                
                                                                        <p *ngIf="legItem.get('pickup.address')?.errors?.invalidAddress"
                                                                            class="mt-2 text-red-600 text-xs">
                                                                            Invalid Address (select from the dropdown)
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <details class="col-span-full group">
                                                            <summary
                                                                class="flex items-center justify-between cursor-pointer">
                                                                <div
                                                                    class="text-xs font-bold underline flex items-center">
                                                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none"
                                                                        viewBox="0 0 24 24" stroke-width="1.5"
                                                                        stroke="currentColor" class="size-4">
                                                                        <path stroke-linecap="round"
                                                                            stroke-linejoin="round"
                                                                            d="M15.042 21.672 13.684 16.6m0 0-2.51 2.225.569-9.47 5.227 7.917-3.286-.672ZM12 2.25V4.5m5.834.166-1.591 1.591M20.25 10.5H18M7.757 14.743l-1.59 1.59M6 10.5H3.75m4.007-4.243-1.59-1.59" />
                                                                    </svg>
                                                                    Additional Information
                                                                </div>
                                                                <svg class="h-5 w-5 transition-transform duration-300 ease-in-out group-open:rotate-180"
                                                                    xmlns="http://www.w3.org/2000/svg" fill="none"
                                                                    viewBox="0 0 24 24" stroke="currentColor">
                                                                    <path stroke-linecap="round" stroke-linejoin="round"
                                                                        stroke-width="2" d="M19 9l-7 7-7-7"></path>
                                                                </svg>
                                                            </summary>
                                                            <div
                                                                class="mt-2 grid grid-cols-1 gap-2 sm:grid-cols-6 items-end border p-2 rounded-lg bg-zinc-950/5 dark:bg-white/5 border-zinc-950/10 dark:border-white/10">
                                                                <ng-container formGroupName="address">
                                                                    <div class="sm:col-span-2">
                                                                        <label for="floor"
                                                                            class="block text-sm font-medium text-main-secondary">Floor
                                                                        </label>
                                                                        <div class="mt-1">
                                                                            <input formControlName="floor" type="text"
                                                                                name="floor" id="floor" />
                                                                        </div>
                                                                    </div>
                                                                    <div class="sm:col-span-2">
                                                                        <label for="aptOrSuite"
                                                                            class="block text-sm font-medium text-main-secondary">APT/SUITE
                                                                        </label>
                                                                        <div class="mt-1">
                                                                            <input formControlName="aptSuiteRoom"
                                                                                type="text" name="aptOrSuite"
                                                                                id="aptOrSuite" />
                                                                        </div>
                                                                    </div>
                                                                </ng-container>
                                                                <div class="sm:col-span-2">
                                                                    <label for="placeName"
                                                                        class="block text-sm font-medium text-main-secondary">Place
                                                                        Type
                                                                    </label>
                                                                    <div class="mt-1">
                                                                        <select name="placeNameAddres"
                                                                            id="placeNameAddres"
                                                                            formControlName="placeName">
                                                                            <option value="">
                                                                                Select Place Name
                                                                            </option>
                                                                            <option *ngFor="let placetype of placetypes"
                                                                                value="{{ placetype.title }}">
                                                                                {{ placetype.title | titlecase }}
                                                                            </option>
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                                <div class="sm:col-span-2">
                                                                    <label for="phoneNumber"
                                                                        class="block text-sm font-medium text-main-secondary">Contact
                                                                        Number
                                                                    </label>
                                                                    <div class="mt-1">
                                                                        <input formControlName="phoneNumber" type="text"
                                                                            name="phoneNumber" id="phoneNumber"
                                                                            />

                                                                        
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </details>
                                                        <div *ngIf="
                                        submitted &&
                                        legItem.get('pickup.phoneNumber')?.errors
                                      ">
                                                                            <p *ngIf="
                                          submitted &&
                                          (legItem.get('pickup.phoneNumber')?.errors
                                            ?.minlength ||
                                            legItem.get('pickup.phoneNumber')
                                              ?.errors?.maxlength)
                                        " class="pt-1 text-red-600 text-xs">
                                                                                Minimum 10 digits are required and
                                                                                maximum 13 digits are allowed
                                                                            </p>
                                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div formGroupName="destination" name="destination">
                                        <div class="mt-4">
                                            <h3 class="text-lg font-medium leading-6 text-xs-dark">
                                                Dropoff
                                            </h3>
                                        </div>
                                        <div class="mt-4 grid grid-cols-1 gap-2 sm:grid-cols-6">
                                            <div
                                                class="sm:col-span-6 border-2 border-dashed border-zinc-950/10 dark:border-white/10 p-2 rounded-lg space-y-2">
                                                <div>
                                                    <div class="grid grid-cols-1 gap-2 sm:grid-cols-6">
                                                        <div
                                                            class="col-span-full grid grid-cols-1 gap-2 sm:grid-cols-6">
                                                            <div class="sm:col-span-2">
                                                                <label for="Address"
                                                                    class="block text-sm font-medium text-main-secondary">Time
                                                                </label>
                                                                <div class="mt-1 relative">
                                                                    <input type="text" name="dropoffTime"
                                                                        id="dropoffTime" formControlName="time" [readOnly]="true"
                                                                        [owlDateTime]="dtDropOffTime"
                                                                        [owlDateTimeTrigger]="dtDropOffTime" />
                                                                    <div
                                                                        class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
                                                                        <span class="text-gray-500 sm:text-sm"
                                                                            id="price-currency">
                                                                            <svg xmlns="http://www.w3.org/2000/svg"
                                                                                class="h-5 w-5 text-xs-light"
                                                                                viewBox="0 0 24 24">
                                                                                <g fill="none" stroke="currentColor"
                                                                                    stroke-linecap="round"
                                                                                    stroke-linejoin="round"
                                                                                    stroke-width="2">
                                                                                    <path
                                                                                        d="M11.795 21H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4" />
                                                                                    <path
                                                                                        d="M14 18a4 4 0 1 0 8 0a4 4 0 1 0-8 0m1-15v4M7 3v4m-4 4h16" />
                                                                                    <path d="M18 16.496V18l1 1" />
                                                                                </g>
                                                                            </svg>
                                                                        </span>
                                                                    </div>
                                                                </div>

                                                                <div *ngIf="
                                    legItem.get('destination.time')?.errors &&
                                    submitted
                                  ">
                                                                    <div *ngIf="
                                      legItem.get('destination.time')?.errors
                                        ?.required
                                    " class="error">
                                                                        <p class="mt-2 text-red-600 text-xs">
                                                                            Time is required
                                                                        </p>
                                                                    </div>
                                                                    <div *ngIf="
                                      legItem.get('destination.time')?.errors
                                        ?.owlDateTimeMin
                                    " class="error">
                                                                        <p class="mt-2 text-red-600 text-xs">
                                                                            Time is required
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                <owl-date-time (afterPickerClosed)="
                                    onDateChange(dropOffForm.get('time'))
                                  " #dtDropOffTime></owl-date-time>
                                                            </div>
                                                            <div formGroupName="address" class="sm:col-span-2">
                                                                <label for="Address"
                                                                    class="block text-sm font-medium text-main-secondary">Address
                                                                    <span class="text-red-600">*</span>
                                                                </label>
                                                                <div class="mt-1 flex gap-px">
                                                                    <input type="text" id="dropoffAddress" class=""
                                                                        placeholder="Enter the address"
                                                                        name="pickupAddress" googlePlace
                                                                        formControlName="name" (onSelect)="setDestinationAddress($event, legIndex)" (input)="onChangeDestinationAddress(legIndex)" />
                                                                </div>
                                                                    <div
                                                                        *ngIf="submitted">
                                                                        <div class="error">
                                                                            <p *ngIf="legItem.get('destination.address.name')?.errors?.required" class="mt-2 text-red-600 text-xs">
                                                                                Address is required
                                                                            </p>

                                                                            <!-- if address exists and methods returns invalid then the issue is with coords 
                                                                                                            (either address could be copy-pasted 
                                                                                                            or typed into input but not chosen from autocomplete list) -->
                                                                            <p *ngIf="legItem.get('destination.address')?.errors?.invalidAddress"
                                                                                class="mt-2 text-red-600 text-xs">
                                                                                Invalid Address (select from the dropdown)
                                                                            </p>
                                                                        </div>
                                                                    </div>

                                                           
                                                              
                                                            </div>
                                                        </div>
                                                        <details class="col-span-full group">
                                                            <summary
                                                                class="flex items-center justify-between cursor-pointer">
                                                                <div
                                                                    class="text-xs font-bold underline flex items-center">
                                                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none"
                                                                        viewBox="0 0 24 24" stroke-width="1.5"
                                                                        stroke="currentColor" class="size-4">
                                                                        <path stroke-linecap="round"
                                                                            stroke-linejoin="round"
                                                                            d="M15.042 21.672 13.684 16.6m0 0-2.51 2.225.569-9.47 5.227 7.917-3.286-.672ZM12 2.25V4.5m5.834.166-1.591 1.591M20.25 10.5H18M7.757 14.743l-1.59 1.59M6 10.5H3.75m4.007-4.243-1.59-1.59" />
                                                                    </svg>
                                                                    Additional Information
                                                                </div>
                                                                <svg class="h-5 w-5 transition-transform duration-300 ease-in-out group-open:rotate-180"
                                                                    xmlns="http://www.w3.org/2000/svg" fill="none"
                                                                    viewBox="0 0 24 24" stroke="currentColor">
                                                                    <path stroke-linecap="round" stroke-linejoin="round"
                                                                        stroke-width="2" d="M19 9l-7 7-7-7"></path>
                                                                </svg>
                                                            </summary>
                                                            <div
                                                                class="mt-2 grid grid-cols-1 gap-2 sm:grid-cols-6 items-end border p-2 rounded-lg bg-zinc-950/5 dark:bg-white/5 border-zinc-950/10 dark:border-white/10">
                                                                <ng-container formGroupName="address">
                                                                    <div class="sm:col-span-2">
                                                                        <label for="floordest"
                                                                            class="block text-sm font-medium text-main-secondary">Floor
                                                                        </label>
                                                                        <div class="mt-1">
                                                                            <input formControlName="floor" type="text"
                                                                                name="floordest" id="floordest" />
                                                                        </div>
                                                                    </div>
                                                                    <div class="sm:col-span-2">
                                                                        <label for="aptOrSuitedest"
                                                                            class="block text-sm font-medium text-main-secondary">APT/SUITE
                                                                        </label>
                                                                        <div class="mt-1">
                                                                            <input formControlName="aptSuiteRoom"
                                                                                type="text" name="aptOrSuitedest"
                                                                                id="aptOrSuitedest" />
                                                                        </div>
                                                                    </div>
                                                                </ng-container>
                                                                <div class="sm:col-span-2">
                                                                    <label for="placeNamedest"
                                                                        class="block text-sm font-medium text-main-secondary">Place
                                                                        Type
                                                                    </label>
                                                                    <div class="mt-1">
                                                                        <select name="placeNameDest" id="placeNameDest"
                                                                            formControlName="placeName">
                                                                            <option value="">
                                                                                Select Place Name
                                                                            </option>
                                                                            <option *ngFor="let placetype of placetypes"
                                                                                value="{{ placetype.title }}">
                                                                                {{ placetype.title | titlecase }}
                                                                            </option>
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                                <div class="sm:col-span-2">
                                                                    <label for="phoneNumberdest"
                                                                        class="block text-sm font-medium text-main-secondary">Contact
                                                                        Number
                                                                    </label>
                                                                    <div class="mt-1">
                                                                        <input formControlName="phoneNumber" type="text"
                                                                            name="phoneNumberdest"
                                                                            id="phoneNumberdest"
                                                                           />
                                                                        
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </details>
                                                        <div *ngIf="
                                                                                                submitted &&
                                                                                                legItem.get('destination.phoneNumber')?.errors
                                                                                              ">
                                                            <p *ngIf="
                                                                                                  submitted &&
                                                                                                  (legItem.get('destination.phoneNumber')
                                                                                                    ?.errors?.minlength ||
                                                                                                    legItem.get('destination.phoneNumber')
                                                                                                      ?.errors?.maxlength)
                                                                                                " class="pt-1 text-red-600 text-xs">
                                                                Minimum 10 digits are required and
                                                                maximum 13 digits are allowed
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="mt-6 grid grid-cols-1 gap-2 sm:grid-cols-6">
                                        <div class="sm:col-span-3">
                                            <label for="generalNotes"
                                                class="block text-sm font-medium text-main-secondary">General Notes
                                                <!-- <span class="text-gray-400">(Public)</span> -->
                                            </label>
                                            <div class="mt-1">
                                                <textarea formControlName="generalNotes" name="generalNotes"
                                                    id="generalNotes"></textarea>
                                            </div>
                                        </div>
                                        <div class="sm:col-span-3">
                                            <label for="privateNotes"
                                                class="block text-sm font-medium text-main-secondary">
                                                Private Notes
                                                <!-- <span class="text-gray-400">(Private)</span> -->
                                            </label>
                                            <div class="mt-1">
                                                <textarea formControlName="privateNotes" name="privateNotes"
                                                    id="privateNotes"></textarea>
                                            </div>
                                        </div>
                                    </div>
                                </fieldset>
                            </ng-container>
                            <div class="grid grid-cols-1 gap-2 sm:grid-cols-6 items-end">
                                <div *ngIf="
                    legForm && legForm.controls && legForm.controls.length < 3
                  " class="mt-4">
                                    <button type="button" class="btn btn-secondary" (click)="addLegItem()">
                                        + Leg
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Addons -->
                    <div name="addons">
                        <div class="mt-4">
                            <h3 class="text-lg font-medium leading-6 text-main-dark">
                                Addon Services
                            </h3>
                        </div>
                        <div class="space-y-2">
                            <div class="mt-4 bg-main-base-100 border-2 border-dashed border-main-base dark:border-white/10 p-2 rounded-lg"
                                *ngFor="let addonItem of addonsFormGroups; index as addonIndex">
                                <div class="grid grid-cols-1 gap-2 sm:grid-cols-6" [formGroup]="addonItem">
                                    <div class="sm:col-span-2">
                                        <label for="addonId" class="block text-sm font-medium text-main-secondary">Item
                                            {{ addonIndex + 1 }}
                                            <span class="text-red-600">*</span></label>
                                        <div class="mt-1">
                                            <ng-select id="addonId" formControlName="addon" [clearable]="false" (ngModelChange)="onSelectAddonItem(addonItem)"
                                                 dropdownPosition="top" class="">
                                                <ng-option value=""> Select Item</ng-option>
                                                <ng-option *ngFor="let addon of addonsList" value="{{ addon.id }}">{{
                                                    addon.title | titlecase
                                                    }} - {{ addon.type === 'percentage' ? (addon.fare + '%') : ('$' + addon.fare) }} </ng-option>
                                            </ng-select>
                                            <div *ngIf="addonItem.controls.addon.errors && submitted">
                                                <div *ngIf="addonItem.controls.addon.errors.required" class="error">
                                                    <p class="mt-2 text-red-600 text-xs">
                                                        Addon Item is required
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="sm:col-span-2">
                                        <label for="quantity"
                                            class="block text-sm font-medium text-main-secondary">Quantity <span
                                                class="text-red-600">*</span>
                                        </label>
                                        <div class="mt-1">
                                            <input formControlName="quantity" type="text" name="quantity" id="quantity"
                                                (ngModelChange)="onSelectAddonItem(addonItem)" />
                                        </div>
                                        <div *ngIf="addonItem.controls.quantity.errors && submitted">
                                            <div *ngIf="addonItem.controls.quantity.errors.required" class="error">
                                                <p class="mt-2 text-red-600 text-xs">
                                                    Quantity is required
                                                </p>
                                            </div>
                                            <div *ngIf="
                          addonItem.controls.quantity.errors.greaterThanZero
                        " class="error">
                                                <p class="mt-2 text-red-600 text-xs">
                                                    Quantity must be greater than 0
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="mt-6">
                                        <label for="sr-only"></label>
                                        <button type="button" class="btn btn-danger"
                                            (click)="removeAddonsItem(addonIndex)">
                                            Remove
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div class="grid grid-cols-1 gap-2 sm:grid-cols-6 items-end">
                                <div class="mt-4">
                                    <button type="button" class="btn btn-secondary" (click)="addAddonsItem()">
                                        + Addon
                                    </button>
                                </div>
                            </div>
                        </div>
                          <!-- Payment -->
                    <div *ngIf="selectedMember?.memberType === 'private_pay'" name="payments">
                        <div class="mt-4">
                            <h3 class="text-lg font-medium leading-6 text-main-dark">
                                Payment Methods
                            </h3>
                        </div>
                        <div class="space-y-2 mt-3">
                            
                    
                            <div class="grid grid-cols-1 gap-2 sm:grid-cols-6 items-start">
                                <div  class="sm:col-span-2" >
                                            <select id="paymentId" formControlName="payments" 
                                                 dropdownPosition="top"    placeholder="Select Payment"  (change)="markPaymentPrimary()">
                                                <option *ngFor="let payment of payments" value="{{payment.id}}">{{payment.last4}} {{payment.cardBrand}}{{payment?.expMonth}}/{{payment?.expYear}} 
                                                    <span *ngIf="payment.isDefault" class="text-xs-light"> (Primary) </span>
                                                </option>
                                            </select>
                                            <div *ngIf="submitted && newTripForm.get('payments')?.errors">
                                                <p *ngIf="newTripForm.get('payments')?.errors?.required" class="mt-2 text-red-600 text-xs">
                                                    Payment method is required
                                                </p>
                                            </div>
                                         
                                    </div>
                                <div>
                                    <button type="button" class="btn btn-secondary  mt-3 sm:mt-0 self-start sm:self-auto" (click)="addPaymentMethod()">
                                        + Card
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
                <div class="pt-4">
                    <div class="flex justify-end gap-2">
                        <button type="submit" class="ml-3 btn btn-secondary" *ngIf="!isFromStandingOrder">
                            {{ tripId ? "Update" : "Create" }}
                        </button>
                        <!-- <button type="button" (click)="dummyData()" class="ml-3 btn btn-primary">Dummy Data</button> -->
                    </div>
                </div>
            </form>
        </div>
        <!-- Member Modal -->
        <div *ngIf="selectedMember" class="flex-shrink-0 lg:w-96">
            <div
                class="rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 shadow-lg p-4">
                <div class="flex justify-between items-start">
                    <div class="flex-1 flex items-center gap-2">
                        <div
                            class="inline-grid size-10 shrink-0 rounded-[20%] align-middle outline outline-1 -outline-offset-1 outline-black/[--ring-opacity] [--ring-opacity:20%] *:rounded-[--avatar-radius] dark:outline-white/[--ring-opacity] overflow-hidden">
                            <img alt="Profile Image" class="relative size-full text-gray-400 ng-star-inserted" [src]="
                  selectedMember?.profileImageURL
                    ? selectedMember.profileImageURL
                    : 'assets/images/profileImagePlaceholder.png'
                " />
                        </div>
                        <div class="flex flex-col">
                            <div class="text-primary text-sm-dark font-bold leading-tight">
                                {{ (selectedMember?.displayName) | titlecase }}
                            </div>
                        </div>
                    </div>
                    <div>
                        <span class="badge-success">{{
                            selectedMember.gender | titlecase
                            }}</span>
                    </div>
                </div>
                <div class="space-y-8">
                    <!-- Trip Information -->
                    <div>
                        <dl
                            class="mt-2 divide-y divide-zinc-950/10 dark:divide-white/10 border-t border-b border-zinc-950/10 dark:border-white/10">
                            <div class="flex justify-between py-3 text-xs font-medium items-center">
                                <dt class="text-xs-light">
                                    Weight <span class="text-xs-light">(lbs)</span>
                                </dt>
                                <dd class="text-xs-dark">
                                    {{ selectedMember.weight ? selectedMember.weight : "N/A" }}
                                </dd>
                            </div>
                            <div class="flex justify-between py-3 text-xs font-medium items-center">
                                <dt class="text-xs-light">Contact Number</dt>
                                <dd class="text-xs-dark">
                                    <div class="leading-tight" phoneNumberFormat [phoneNumber]="selectedMember?.contactNumber">
                                        {{ selectedMember?.contactNumber }}
                                    </div>
                                    <!-- <div class="leading-tight" class="text-xs-light">
                                        {{selectedMember.phoneNumber}}
                                    </div> -->
                                </dd>
                            </div>
                            <div class="flex justify-between py-3 text-xs font-medium items-center">
                                <dt class="text-xs-light">Email</dt>
                                <dd class="text-xs-dark">
                                    {{ selectedMember.email }}
                                </dd>
                            </div>
                            <div class="flex justify-between py-3 text-xs font-medium items-center">
                                <dt class="text-xs-light">Spoken Languages</dt>
                                <dd class="text-xs-dark flex gap-1">
                                    <span class="">
                                        {{
                                        selectedMember?.languageSpoken
                                        ? (selectedMember?.languageSpoken | titlecase)
                                        : "N/A"
                                        }}
                                    </span>
                                </dd>
                            </div>
                            <div class="flex justify-between py-3 text-xs font-medium items-center">
                                <dt class="text-xs-light">Address</dt>
                                <dd class="text-xs-dark">{{ selectedMember.address?.name }}</dd>
                            </div>
                            <div class="flex justify-between py-3 text-xs font-medium items-center">
                                <dt class="text-xs-light">Member Type</dt>
                                <dd class="text-xs-dark">
                                    <div class="badge-primary">
                                        {{ selectedMember.memberType | titlecase }}
                                    </div>
                                </dd>
                            </div>
                            <div class="flex justify-between py-3 text-xs font-medium items-center">
                                <dt class="text-xs-light">SpaceType</dt>
                                <dd class="text-xs-dark">
                                    <span
                                        *ngIf="selectedMember?.spaceType && preSpaceTypeList?.[selectedMember.spaceType]; else spaceTypeNotFound">
                                        {{
                                        preSpaceTypeList[selectedMember.spaceType]
                                        ?.title | uppercase
                                        }}
                                    </span>
                                    <ng-template #spaceTypeNotFound>N/A</ng-template>
                                </dd>
                            </div>
                            <div class="flex justify-between py-3 text-xs font-medium items-center">
                                <dt class="text-xs-light">Responsible Party Name</dt>
                                <dd class="text-xs-dark">
                                    {{ ((selectedMember.responsibleParty?.name) | titlecase) || "N/A" }}
                                </dd>
                            </div>
                            <div class="flex justify-between py-3 text-xs font-medium items-center">
                                <dt class="text-xs-light">Responsible Party Phone Number</dt>
                                <dd class="text-xs-dark" phoneNumberFormat [phoneNumber]="selectedMember?.responsibleParty?.phoneNumber">
                                    {{ selectedMember.responsibleParty?.phoneNumber || "N/A" }}
                                </dd>
                            </div>
                            <div class="flex justify-between py-3 text-xs font-medium items-center">
                                <dt class="text-xs-light">Appointment Type</dt>
                                <dd class="text-xs-dark">
                                    <span
                                        *ngIf="selectedMember?.appointmentType && preAppointmentTypes?.[selectedMember.appointmentType]; else typeNotFound">
                                        {{
                                        preAppointmentTypes[selectedMember.appointmentType]?.title
                                        | titlecase
                                        }}
                                    </span>
                                    <ng-template #typeNotFound>N/A</ng-template>
                                </dd>
                            </div>
                            <div class="flex justify-between py-3 text-xs font-medium items-center">
                                <dt class="text-xs-light">Status</dt>
                                <dd class="text-xs-dark">
                                    <span [ngClass]="{
                      'badge-success': selectedMember?.isActive,
                      'badge-danger': !selectedMember?.isActive
                    }">
                                        {{ selectedMember?.isActive ? "Active" : "Inactive" }}
                                    </span>
                                </dd>
                            </div>
                            <div class="flex flex-col justify-between text-xs font-medium items-start">
                                <dt class="text-xs-light">General Notes</dt>
                                <div class="w-72 line-clamp-2">
                                    <dd class="text-xs-dark">
                                        {{
                                        selectedMember.generalNotes
                                        ? selectedMember.generalNotes
                                        : "N/A"
                                        }}
                                    </dd>
                                </div>
                            </div>
                            <div class="flex flex-col justify-between py-3 text-xs font-medium items-start">
                                <dt class="text-xs-light">Private Notes</dt>
                                <div class="w-72 line-clamp-2">
                                    <dd class="text-xs-dark">
                                        {{
                                        selectedMember.privateNotes
                                        ? selectedMember.privateNotes
                                        : "N/A"
                                        }}
                                    </dd>
                                </div>
                            </div>
                        </dl>
                    </div>
                </div>
            </div>
        </div>

        <!-- Calculate Fare Modal -->
    </div>
</section>

<app-member-wrapper *ngIf="addMember" [source]="'modal'" [memberId]="form.member.value" (onSave)="onSaveMember($event)"
    (onCloseModal)="addMember = false"></app-member-wrapper>
<app-payment-card-modal
  *ngIf="isCardModalOpen"
  [member]="selectedMember"
  (close)="onCloseCardModal($event)">
</app-payment-card-modal>


